module.exports = __webpack_public_path__ + "static/media/contact3-EN.1258adba.png";